import { useEffect } from 'react';
import { KeysToActionsMap } from './types';

export function useOnKeyDown(keysToActionsMap?: KeysToActionsMap) {
	useEffect(() => {
		if (!keysToActionsMap) {
			return;
		}

		const onKeyDown = (keyboardEvent: KeyboardEvent) => {
			keysToActionsMap[keyboardEvent.key]?.();
		};
		window.addEventListener('keydown', onKeyDown);

		return () => {
			window.removeEventListener('keydown', onKeyDown);
		};
	}, [keysToActionsMap]);
}
